import {  EntityTypeValue, } from './entity-type-component.domain';
import {  GenderValue, } from './gender-component.domain';
import {    PersonalAssetsValue, } from './personal-assets-component.domain';
import {    PersonalLiabilitiesValue, } from './personal-liabilities-component.domain';
import {  PropertyOwnerWithAddressValue, } from './property-owner-with-address-component.domain';
import {  TitleSelectionValue, } from './title-selection-component.domain';
import {  YesNoValue, } from './yes-no-component.domain';
import { Address2ComponentValue } from './address2-component.domain';
import {Moment} from 'moment';
import {BusinessNumberSearchValue} from './business-number-search-component.domain';
import {CountryOfCitizenshipValue} from './individual-form-component.domain';
import {IdentificationComponentValue} from './identification-component.domain';
import {UploadFileValue} from './file-upload-component.domain';

export type EntityPartner = {
  kind: 'Partner',
  type: 'Entity',
  organisation: Exclude<BusinessNumberSearchValue, null>,
  organisationType: Exclude<EntityTypeValue, null>,
  acn: string,
  abn: string,
  manualEntry: boolean,
};
export type IndividualPartner = {
  kind: 'Partner',
  type: 'Individual',
  // The saved individual a reopened draft prefilled this from; unset for a person typed in.
  guid?: string,
  title: TitleSelectionValue,
  firstName: string,
  lastName: string,
  middleName: string,
  // no longer collected by the unified individual-form; kept optional for historical values
  gender?: GenderValue,
  dob: Moment,
  // no longer collected per person; guarantor selection happens on the KYB Key People screen
  guarantor?: YesNoValue,
  hasAlias?: boolean,
  aliasNames?: string | null,
  countryOfCitizenship?: CountryOfCitizenshipValue,
  identification?: IdentificationComponentValue,
  idDocument?: UploadFileValue,
  residentialAddress: Address2ComponentValue,
  propertyOwner: PropertyOwnerWithAddressValue,
  email: string,
  mobileNumber: string,
  personalAssets: PersonalAssetsValue,
  personalLiabilities: PersonalLiabilitiesValue,
};
export type PartnerValue = (IndividualPartner | EntityPartner)[] | null;
